import { assetImagePath } from 'interfaces/constants'

import { StyledButton } from './index.styled'

const GoTopButton = () => {
  const scrollToTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }

  return (
    <StyledButton>
      <img
        loading="lazy"
        src={`${assetImagePath}/chevronUpCircle.svg`}
        className="button-image"
        onClick={scrollToTop}
        alt=""
      />
    </StyledButton>
  )
}

export default GoTopButton
